import type { MyAccountAddress } from '../MyAccount.types';

interface AddressCardProps {
  address: MyAccountAddress;
  onSetPreferred: () => void;
  onEdit: () => void;
  onRemove: () => void;
}

export const AddressCard = ({ address, onSetPreferred, onEdit, onRemove }: AddressCardProps) => (
  <article className="addr-card" data-preferred={String(address.isPrimary)}>
    <button type="button" className="addr-star" onClick={onSetPreferred} aria-label="Set as preferred address">
      <svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
    </button>
    <span className="addr-default">
      <svg viewBox="0 0 12 12"><polyline points="2 6 5 9 10 3" fill="none" stroke="currentColor" strokeWidth="1.5" /></svg>
      Preferred
    </span>
    <div className="addr-body">
      <h4 className="addr-name">{address.name}</h4>
      <address className="addr-lines">
        {address.companyName && <>{address.companyName}<br /></>}
        {address.addressLine1}<br />
        {address.addressLine2 && <>{address.addressLine2}<br /></>}
        {address.addressLine3 && <>{address.addressLine3}<br /></>}
        {address.zipCode}, {address.countryName}
      </address>
      {address.phone && (
        <p className="addr-phone"><span className="k">T:</span> {address.phone}</p>
      )}
    </div>
    <div className="addr-actions">
      <button type="button" className="ma-btn-secondary" style={{ flex: 1 }} onClick={onEdit}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
        Edit
      </button>
      <button type="button" className="ma-btn-ghost" onClick={onRemove}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
        Remove
      </button>
    </div>
  </article>
);
